import * as app from "@highmarch/app";
import type { PlayerProfile } from "@highmarch/domain";

/**
 * The gold Research tree's facts for the Shop (M35): how many nodes the player can buy now and the cheapest next
 * cost, from `@highmarch/app` `researchSummary(profile)` — the research package's pure summary (M35 contract). Read through
 * the module namespace so this branch builds before that package lands: until it does there is no summary (null),
 * the Shop's Research row says what research is, and nothing is counted on the Shop tab.
 */
export interface ResearchRowFacts {
  /** Nodes available to buy now (unlocked and affordable). */
  readonly available: number;
  /** The cheapest next node's gold cost, or null when nothing is left to research. */
  readonly cheapest: number | null;
  /** Nodes not yet researched (owned or not open yet); 0 when the whole tree is done. */
  readonly left: number;
}

type Summary = { readonly available?: number; readonly availableCount?: number; readonly cheapest?: number | null; readonly cheapestCost?: number | null; readonly owned?: number; readonly total?: number };

export function researchFacts(profile: PlayerProfile): ResearchRowFacts | null {
  const fn = (app as unknown as Record<string, unknown>)["researchSummary"];
  if (typeof fn !== "function") return null;
  try {
    const s = (fn as (p: PlayerProfile) => Summary)(profile);
    return { available: Number(s.available ?? s.availableCount ?? 0), cheapest: s.cheapest ?? s.cheapestCost ?? null, left: Math.max(0, Number(s.total ?? 0) - Number(s.owned ?? 0)) };
  } catch { return null; }
}
